import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const FacilitatorRegistration = lazy(() => import('../../container/facilitator/facilitatorRegistration'));
const FacilitatorList = lazy(() => import('../../container/facilitator/facilitatorList'));
const FacilitatorUpdate = lazy(() => import('../../container/facilitator/facilitatorUpdate'));
const FacilitatorDetails = lazy(() => import('../../container/facilitator/facilitatorDetails'));

function FacilitatorRoute() {
  return (
    <Routes>
      <Route path="register" element={<FacilitatorRegistration />} />
      <Route path="list" element={<FacilitatorList />} />
      <Route path="update/:id" element={<FacilitatorUpdate />} />
      <Route path="details/:id" element={<FacilitatorDetails />} />
    </Routes>
  );
}

export default FacilitatorRoute;
